import useTranslation from "utils/hooks/useTranslation";
import { SvgChat } from "./svg";
import { useCallback } from "react";
import NeedHelpPopup from "./popups/NeedHelpPopup";
import { usePopup } from "providers/PopupProvider";

const NeedHelp: React.FC = () => {
    const { t } = useTranslation();
    const { openPopup, closeLastPopup } = usePopup();
    const disableHelp = true;

    const openHelpPopup = useCallback(() => {
        openPopup(
            <NeedHelpPopup
                closePopup={closeLastPopup}
            ></NeedHelpPopup>
        )
    }, [])

    return <>
        {!disableHelp && <group
            data-position="fixed"
            data-background="main-color-custom-lighter"
            data-length="220"
            data-align="center"
            data-radius="extra-special"
            data-gap="5"
            data-space="20"
            data-bottom="100" data-right="20"
            data-adaptive="desktop"
            data-index="101"
            data-elevation="5"
        >
            <group data-justify="center">
                <icon data-svg-size="40" data-svg-color="main"><SvgChat /></icon>
            </group>
            <group data-justify="center">
                <text data-text-size="large" data-weight="600">{t("HELP_BUTTON")}</text>
            </group>
            <group data-justify="center" data-cursor="pointer" data-color="secondary" data-interactive="highlight" onClick={openHelpPopup}>
                <text data-text-size="medium">{t("TUTORIAL_HELP")}</text>
            </group>
        </group>}
    </>
}

export default NeedHelp;